import React, { useEffect, useState } from "react";
import "./App.css";
import AppFeedback from "./components/atoms/AppFeedback/AppFeedback";
import Layout from "./components/molecules/Layout/Layout";
import { useAuth } from "./resources/AuthProvider";
import { PageType } from "./types/Page";

function App() {
  const { isAuthenticated, userPageList } = useAuth();
  const [filteredPages, setFilteredPages] = useState<PageType[]>([]);

  useEffect(() => {
    localStorage.setItem("lastVisited", location.pathname);
  }, [location]);

  useEffect(() => {
    if (isAuthenticated()) {
      const transformedPages = transformToPageType(userPageList);
      setFilteredPages(transformedPages);
    } else {
      setFilteredPages([]);
    }
  }, [isAuthenticated, userPageList]); // Dependências do useEffect

  // Define o tema da aplicação
  sessionStorage.setItem("theme", "light");

  return (
    <div className="App">
      <AppFeedback />
      <Layout pages={filteredPages} />
    </div>
  );
}

function transformToPageType(pages: string[]): PageType[] {
  return pages.map((page) => {
    if (page === "") {
      return {
        title: "Home", // Exceção para o valor vazio
        url: "/", // URL para a página inicial
      };
    }

    return {
      title: page.charAt(0).toUpperCase() + page.slice(1), // Capitaliza o primeiro caractere do título
      url: `/${page}`, // Cria o URL da página com base no nome
    };
  });
}

export default App;
